import request from '@/api/request'
// 在线课程
export function onlineCourse() {
  return request({
    url: `/education/userCourse/onlineCourse`,
    method: 'get'
  })
}
// 课程类目
export function courseTypeList() {
  return request({
    url: `/education/courseType/list`,
    method: 'get'
  })
}
// 根据课程类目分类
export function onlineCourseByType(courseTypeId) {
  return request({
    url: `/education/userCourse/onlineCourseByType/?courseTypeId=${courseTypeId}`,
    method: 'get'
  })
}
// 在线课程目录
export function onlineChapter(courseGroupId) {
  return request({
    url: `/education/userCourse/onlineChapter/?courseGroupId=${courseGroupId}`,
    method: 'get'
  })
}
// 根据章节id查询信息
export function getChapterById(chapterId) {
  return request({
    url: `/education/userCourse/getChapterById/?chapterId=${chapterId}`,
    method: 'get'
  })
}
// 上传学生反馈
// export function uploadFiles(chapterGroupId, courseGroupId, files, onUploadProgress) {
//   return request({
//     url: `/education/chapterFeedback/uploadFiles?chapterGroupId=${chapterGroupId}&courseGroupId=${courseGroupId}`,
//     method: 'post',
//     data: files,
//     timeout: 60 * 60 * 1000,
//     onUploadProgress
//   })
// }
export function uploadFiles(feedbackFile) {
  return request({
    url: `/education/chapterFeedback/uploadFiles`,
    method: 'post',
    data: feedbackFile
  })
}
// 学生反馈列表
export function studentFeedbackList(chapterGroupId, courseGroupId) {
  return request({
    url: `/education/chapterFeedback/studentFeedbackList?chapterGroupId=${chapterGroupId}&courseGroupId=${courseGroupId}`,
    method: 'get'
  })
}
// 根据课程id获取文件列表
export function documentByChapterId(chapterId) {
  return request({
    url: `/education/chapter/documentByChapterId?chapterId=${chapterId}`,
    method: 'get'
  })
}
// 根据课程id删除文件列表
export function deleteDocument(chapterGroupId, courseGroupId, documentId) {
  return request({
    url: `/education/chapterFeedback/deleteDocument?chapterGroupId=${chapterGroupId}&courseGroupId=${courseGroupId}&documentId=${documentId}`,
    method: 'delete'
  })
}

// 记录时长
export function recordDuration(audioDuration, videoDuration, recordId) {
  return request({
    url: `/education/userCourse/recordDuration`,
    method: 'post',
    params: { audioDuration, videoDuration, recordId }
  })
}
